import { instance, instanceWithAuth } from "@/api/index";

function saveScrapDataAndGetResult(data) {
    // return instance.post("/tax/save", data);
    return instanceWithAuth.post("/tax/save", data);
}

function getSendList(params) {
    return instanceWithAuth.get("/tax/send-list", { params: params });
}

function psnLogin(params) {
    return instance.post("/psn/login", params);
}

function psnApi(params) {
    return instanceWithAuth.post("/psn/api", params)
}

function psnSave(params) {
    return instanceWithAuth.post("/psn/save", params);
}

function getSample(params) {
    return instance.get("/test/sample", { params: params })
}

export { saveScrapDataAndGetResult, getSendList, psnLogin, psnApi, psnSave, getSample }